export default __webpack_public_path__ + "static/media/banknote.06c7031a.jpg";